





















import BuyNowButton from "./BuyNowButton";
import Pricing from "../../../../../../frontend/components/Pricing.vue";

export default BuyNowButton.extend(
    {
      name: 'MultiFlexBuyNowButton',
      components: {
        Pricing
      },
      computed: {
        buttonText() {
          if (!this.isForSale) {
            return (this as any).$t('12835.App_hotelDetailsBookButtonSoldOut');
          }
          return (this as any).$t('28272.App_HotelDealAvailabilityBuyNowCartButtonTitle');
        },
      }
    });
